var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tabnav__tabs"},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:index,staticClass:"tabnav__tabs-item"},[_c('router-link',{attrs:{"id":'tab-' + index,"to":tab.path}},[_vm._v("\n      "+_vm._s(tab.name)+"\n    ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }